import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// import Header from '@containers/common/Header';
// import { displayHeaders } from '@helpers/generic';
import { getStoreThemeUrl } from '@reducers/theme';
import { bindActionCreators } from 'redux';
import {
  authenticate,
  subscribeToStoreChecks,
  subscribeToStoreNotifications,
  getStoreNotifications,
  getStoreChecks,
  connect as socketConnector
} from '../../../sockets/communicator';
import { getObjectValue } from '@utility/helperFunction';
import EventEmitter from '@utility/eventSubscribers';
import {
  setCardReaderStatus, setInActivityStatus, setSocketConnection, logout, setOpen,
  setScreenSaverStatus,
} from '@reducers/oauth';
import InActivity from '@containers/common/InActivity';
import { flowType } from '@utility/userInfo';
import { updateChecksAfterResponse, getAllChecks, getAllCheckPreps } from '@reducers/storeChecks';
import { setIsAssisstance } from '@reducers/checks';
import {
  checkVoid, clearCart, removeSeat, removePaymentCheck, addChecks, setSeat
} from '@reducers/orders';
import {
  clearAuthResponse
} from '@reducers/payment';
import {
  logCapiClientHealthInfo
} from '@reducers/utils';
import { setNotification } from '@reducers/notification';
import { subscribe } from '../../../CApiWebSocket/Subscriber';
// import { APP_CONFIG } from '@constants';

class ScrollToTop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // showHeader: true,
      shouldFlip: false,
    };
  }

  logCapiClientHealthInfoHandler = (data)  => {
    return this.props.logCapiClientHealthInfo(data);
  };

  componentDidMount() {
    if (window.ReactNativeWebView) {
      // EventEmitter.cardreaderInitialized((status) => {
      //   this.props.setCardReaderStatus(status);
      // });
      EventEmitter.deviceStatus((deviceState) => {
        if (deviceState === 'DEVICE_UNPLUGGED' || deviceState === 'DEVICE_CONNECTING' || deviceState === 'DEVICE_AVAILABLE') {

        } else {
          // props.setNotification({
          //   type: 'danger',
          //   message: 'Card Reader Error'
          // });
        }
        // this.props.setCardReaderStatus(status);
      });
      // EventEmitter.reLounchApp();
    }
    this.props.setScreenSaverStatus(this.props.deviceInfo?.deviceTypeId === 7 || this.props.deviceInfo?.deviceTypeId === 6);
    this.props.setSocketConnection(false);
    const auth = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('auth')), 0);
    const connectionOptions = {
      reconnectionDelay: 500,
      reconnectionAttempts: Infinity,
    };
    if (auth) {
      socketConnector({
        url: auth?.cApiHostname ? auth.cApiHostname : process.env.REACT_APP_API_SOCKET_HOST || 'https://yapi.dev.onedine.com/iapi/connect',
        connectCallback: () => {
          console.warn('websocket connection successful');
        },
        disconnectCallback: () => {
          console.warn('websocket connection unsuccessful');
        },
        connectionOptions,
        apiKey: this.props.deviceInfo.apiKey,
        deviceExternalId: this.props.deviceInfo.deviceExternalId,
        storeId: this.props.deviceInfo.storeId,
        deviceTypeId: this.props.deviceInfo.deviceTypeId,
        logCapiClientHealthInfo: this.logCapiClientHealthInfoHandler,
        subscriber: (data) => { subscribe(data); }
      });
    }
    // https://yapi.dev.onedine.com/iapi/connect

    this.getWebSocketsData(auth);
  }

  static getDerivedStateFromProps(props, state) {
    if ([7].includes(props.deviceInfo && props.deviceInfo.deviceTypeId) && getObjectValue(() => state.shouldFlip !== props.userInfo?.flipView, false)) {
      if (document.getElementById('userPreference')) {
        const prevUserPreference = document.getElementById('userPreference');
        try {
          document.getElementsByTagName('head')[0].removeChild(prevUserPreference);
        } catch (err) {
          console.log(err);
        }
      }
      if (getObjectValue(() => JSON.parse(window.sessionStorage.getItem('userInfo')).flipView, false) && !document.getElementById('userPreference')) {
        const style = document.createElement('style');
        const css = '.rowReverse { flex-direction: row-reverse !important; }';
        style.id = 'userPreference';
        style.appendChild(document.createTextNode(css));
        document.getElementsByTagName('head')[0].appendChild(style);
      }
      if (window.ReactNativeWebView) {
        EventEmitter.postFlipSetting(props.userInfo?.flipView);
      }
      return { shouldFlip: props.userInfo?.flipView };
    }
    if (!props.userInfo && window.ReactNativeWebView) {
      EventEmitter.postFlipSetting(false);
      return { shouldFlip: false };
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.socketConnected !== prevProps.socketConnected) {
      this.getWebSocketsData(this.props.auth);
    }
    window.scrollTo(0, 0);
  }

  componentDidCatch(error) {
    console.error('errros', error);
    // if (error) {
    //   this.props.history.replace(`${APP_CONFIG.BASE_URL}/error`);
    // }
  }

  getWebSocketsData = (auth) => {
    if (auth && !auth?.cApiHostname) {
      // const headers = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('headers')), {});
      authenticate({ headers: { 'api-key': auth.syncApiKey }, id: auth.id });
      subscribeToStoreChecks(getObjectValue(() => auth.id, 0));
      if (![3, 10].includes(this.props.deviceInfo?.deviceTypeId)) {
        getStoreChecks(getObjectValue(() => auth.id, 0));
      }
      if (![11, 8].includes(this.props.deviceInfo?.deviceTypeId)) {
        subscribeToStoreNotifications(getObjectValue(() => auth.id, 0));
        getStoreNotifications(getObjectValue(() => auth.id, 0));
      }
    } else if (this.props?.deviceInfo?.storeId) {
      if (flowType() == 'kds') {
        this.props.getAllCheckPreps(this.props.deviceInfo.storeId);
        this.props.getStoreThemeUrl(this.props.auth.brandId, this.props?.deviceInfo?.storeId, 'kds')
      } else {
        this.props.getAllChecks(this.props.deviceInfo.storeId);
      }
    }
    if (auth && ![11, 8, 14].includes(this.props.deviceInfo?.deviceTypeId)) {
      const deviceType = flowType();
      this.props.getStoreThemeUrl(this.props.auth.brandId, this.props.deviceInfo.storeId, deviceType === 'paymentTerminal' ? 'serverApp' : deviceType);
    }
  }

  render() {
    return (
      <>
        {this.props.children}
        {<InActivity {...this.props} />}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getStoreThemeUrl,
  setCardReaderStatus,
  setInActivityStatus,
  setSocketConnection,
  updateChecksAfterResponse,
  setIsAssisstance,
  checkVoid,
  clearCart,
  removeSeat,
  removePaymentCheck,
  addChecks,
  setSeat,
  logout,
  setOpen,
  clearAuthResponse,
  setNotification,
  setScreenSaverStatus,
  getAllChecks,
  getAllCheckPreps,
  logCapiClientHealthInfo
}, dispatch);

const mapStateToProps = ({ orders, oauth, storeChecks }) => ({
  deviceInfo: oauth.deviceInformation,
  userInfo: oauth.loggedInUserData,
  checkListHashTable: storeChecks.checkListHashTable,
  subscribeChecksId: storeChecks.subscribeChecksId,
  auth: oauth.authInfo,
  inActivityStatus: oauth.inActivityStatus,
  socketConnected: oauth.socketConnected,
  // check: orders.seats,
  stopPopUp: oauth.isOpen,
  cart: orders.cart,
  speedOrderStatus: orders.speedOrderStatus,
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ScrollToTop));
